import { render, staticRenderFns } from "./admin_xmzs.vue?vue&type=template&id=6e44d092&scoped=true"
import script from "./admin_xmzs.vue?vue&type=script&lang=js"
export * from "./admin_xmzs.vue?vue&type=script&lang=js"
import style0 from "./admin_xmzs.vue?vue&type=style&index=0&id=6e44d092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e44d092",
  null
  
)

export default component.exports